import { Autocomplete, TextField } from "@mui/material";
import React, { useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";

import { useEffect } from "react";
import { MedioContactoArray } from "../../../Arrays/MedioContactoArray";
import { TipoContactoArray } from "../../../Arrays/TipoContactoArray";
import { ValidaContacto } from "./ValidaContacto";
import { useSelector } from "react-redux";

export const ModalContactoEditarNew = ({ orden, setContactos }) => {
  const { idcliente } = useSelector((store) => store.clientes);
  const closedModal = () => {
    var modal = document.getElementById("modal-contacto");
    modal.style.display = "none";
  };
  const [state, setState] = useState({
    mediocontacto: "",
    tipocontacto: "",
    valor: "",
    comentarios: "",
  });
  const onGuardar = () => {
    var valido = ValidaContacto(state);
    if (valido !== false) {
      valido.idcliente = Number(idcliente);
      valido.orden = Number(orden);
      request
        .post("ClientesDatosContacto", valido)
        .then(async (result) => {
          await Swal.fire("Clientes", result.mensaje, "success");
          setContactos(result.listado);
          setState({
            mediocontacto: "",
            tipocontacto: "",
            valor: "",
            comentarios: "",
          });
          closedModal();
        })
        .catch((error) => {
          Swal.fire("Clientes", JSON.stringify(error), "error");
        });
    }
  };

  useEffect(() => {
    if (orden !== undefined && orden !== null && Number(orden) > 0) {
      request
        .get(
          `ClientesDatosContacto/BuscarID?idcliente=${Number(
            idcliente
          )}&orden=${Number(orden)}`
        )
        .then((result) => {
          setState({
            mediocontacto: result.medio_contacto,
            tipocontacto: result.tipo_contacto,
            valor: result.valor,
            comentarios: result.comentarios,
          });
        })

        .catch((error) => {
          Swal.fire("Clientes", JSON.stringify(error), "error");
        });
    }
  }, [orden]);
  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  };
  return (
    <div id="modal-contacto" class="modal">
      <div class="modal-content-clientes">
        <div class="modal-header-contacto">
          <span class="close" onClick={closedModal}>
            &times;
          </span>
          <div className="encabezado">
            <div className="titulo">
              {orden === 0 ? "REGISTRAR CONTACTO" : "ACTUALIZAR CONTACTO"}
            </div>
            <div className="border-green"></div>
          </div>
        </div>
        <div class="modal-body-clientes">
          <TextField
            fullWidth
            label="Valor"
            size="small"
            color="success"
            className="mb-15"
            type="text"
            value={state.valor}
            onChange={({ target }) =>
              setState({
                ...state,
                valor: target.value.toUpperCase(),
              })
            }
            inputProps={{
              maxLength: state.mediocontacto === "C - CORREO" ? 150 : 10,
            }}
            multiline
            maxRows={2}
          />

          <TextField
            fullWidth
            label="Comentarios"
            size="small"
            color="success"
            className="mb-15"
            value={state.comentarios}
            onChange={({ target }) =>
              setState({
                ...state,
                comentarios: target.value.toUpperCase(),
              })
            }
            inputProps={{
              maxLength: 500,
            }}
            multiline
            maxRows={2}
          />
        </div>
        <div className="footer-guardar-domicilio">
          <div className="button-guardar" onClick={onGuardar}>
            Guardar
          </div>
        </div>
      </div>
    </div>
  );
};
